type ErrorHandlerOptions<T> = {
  operation: () => Promise<T>;
  onError?: (error: unknown) => void;
  onFinally?: () => void;
};

async function handleAsyncOperation<T>({
  operation,
  onError,
  onFinally,
}: ErrorHandlerOptions<T>): Promise<T | undefined> {
  try {
    return await operation();
  } catch (error) {
    onError?.(error);
    return undefined;
  } finally {
    onFinally?.();
  }
}

export default handleAsyncOperation;
